import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockQCEntries } from '../data/mockData';
import { QCEntry } from '../types';
export function GRNList() {
  const navigate = useNavigate();
  // Filter only passed QC entries
  const passedQCEntries = mockQCEntries.filter(q => q.qcStatus === 'Passed');
  const columns: Column<QCEntry>[] = [{
    key: 'qcReferenceNo',
    label: 'GRN No',
    render: q => <span className="font-medium text-indigo-600" data-id="element-1043">
          {q.qcReferenceNo.replace('QC-', 'GRN-')}
        </span>
  }, {
    key: 'product',
    label: 'Product/Item'
  }, {
    key: 'warehouse',
    label: 'Warehouse'
  }, {
    key: 'acceptedQty',
    label: 'Accepted Qty',
    render: q => <span className="font-medium text-green-600" data-id="element-1044">{q.acceptedQty}</span>
  }, {
    key: 'qcInspector',
    label: 'Inspector'
  }, {
    key: 'inspectionDate',
    label: 'Inspection Date'
  }, {
    key: 'qcStatus',
    label: 'Status',
    render: q => <StatusBadge status={q.qcStatus} data-id="element-1045" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1046">
      <div className="flex items-center justify-between" data-id="element-1047">
        <div data-id="element-1048">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1049">GRN Report</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1050">
            Goods Received Notes for QC-passed items.
          </p>
        </div>
      </div>

      <div className="flex-1" data-id="element-1051">
        <DataTable columns={columns} data={passedQCEntries} keyExtractor={item => item.id} searchPlaceholder="Search GRN entries..." onRowClick={item => navigate(`/grn/${item.id}`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-1053">
              <button onClick={e => {
          e.stopPropagation();
          navigate(`/grn/${item.id}`);
        }} className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50" data-id="element-1054">
                <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-1055" /> View Report
              </button>
            </div>} data-id="element-1052" />
      </div>
    </div>;
}